type PlanFeatureSection = {
  key: string;
  options: { text: string; textAdded?: string }[] | string[];
};

export type PlansType = {
  planType: 'Free' | 'Paid';
  title: string;
  price: string;
  durationText: string;
  targetPeople: string;
  btnText: string;
  features: PlanFeatureSection[];
};

export const PLANS: PlansType[] = [
  {
    planType: 'Free',
    title: 'FREE',
    price: '$0 / mo',
    durationText: '',
    targetPeople: 'for students & personal projects',
    btnText: 'Current Plan',
    features: [
      {
        key: 'Storage & Bandwidth',
        options: [
          { text: 'Upload/storage', textAdded: '500 MB' },
          { text: 'Bandwidth', textAdded: '5 GB' },
        ],
      },
      {
        key: 'Virtual Experience Creation',
        options: [
          'Single Sign On',
          'Pre-built Interactions',
          'Template scenes',
          'Procedural Generation Tools',
        ],
      },
    ],
  },
  {
    planType: 'Paid',
    title: 'PAID',
    price: '',
    durationText: '',
    targetPeople:
      'for Freelancers, Studios, or Retailers \n Get in touch to find the right strategy for your organization',
    btnText: 'Contact Sales',
    features: [
      {
        key: 'All of Free +',
        options: [],
      },
      {
        key: 'Experience Creation',
        options: [
          'Custom domains',
          'Custom UI',
          'White-label',
          '3D navigation (coming soon)',
        ],
      },
      {
        key: 'UX & Interaction',
        options: [
          'Custom logic & interactions',
          'API integrations',
          'Token Gated Rooms',
          'Gamification features',
          'Connectivity tools (coming soon)',
        ],
      },
      {
        key: 'Analytics & Management',
        options: [
          'Analytics',
          'Commerce tools',
          'Data Export',
          'Markets',
          'Role Controls (RBAC)',
          'Security',
          'Dedicated Success Manager',
          'Self-Hosted Infrastructure',
          'Managed SaaS',
          'Services Availability',
        ],
      },
    ],
  },
];
